import React from 'react';
import { LinksList, Wrapper } from './sidebar.styles';
import { SidebarLink } from '../sidebar-link/sidebar-link';
import { useCurrentUserSelector } from '../../../entities/current-user/model/selectors';
import { LINKS_BY_ROLE, LINK_WIDTH_BY_ROLE } from './constants';
import { getCurrentUserRole } from '@shared/lib/utils/get-current-user-role/get-current-user-role';

export const Sidebar: React.FC = () => {
    const user = useCurrentUserSelector();
    const role = getCurrentUserRole(user);

    if (!role) {
        return null;
    }

    return (
        <Wrapper>
            <LinksList $linkWidth={LINK_WIDTH_BY_ROLE[role]}>
                {LINKS_BY_ROLE[role].map(({ linkProps, Icon }) => (
                    <SidebarLink key={`${linkProps.href}_${linkProps.text}`} {...linkProps}>
                        {Icon}
                    </SidebarLink>
                ))}
            </LinksList>
        </Wrapper>
    );
};
